import { css } from "styled-components";

export const buttonCssReset = css`
  cursor: pointer;

  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  text-align: inherit;
  outline: none;

  background: transparent;

  /* inherit font & color from ancestor */
  color: inherit;
  font: inherit;

  /* Normalize line-height. Cannot be changed from normal in Firefox 4+. */
  line-height: normal;

  /* Corrects font smoothing for webkit */
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
`;

/**
 * Creates a shouldForwardProp function based on the parameter
 * @param propNames An array containing the name of each prop that should be filtered out
 * @returns A shouldForwardProp function
 */
export function excludeProps(propNames: string[]): (prop: string) => boolean {
  return prop => !propNames.includes(prop);
}
